import { render, staticRenderFns } from "./CruiseDetailsMatching.vue?vue&type=template&id=4dfee066&"
import script from "./CruiseDetailsMatching.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailsMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports